import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getDocumentTitle } from '../utils/pageTitle';

/**
 * Sets `document.title` from the current route (`CronPay | Page name`).
 */
const DocumentTitle = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        document.title = getDocumentTitle(pathname, search);
    }, [pathname, search]);

    return null;
};

export default DocumentTitle;
